export default __webpack_public_path__ + "media/images/apartment_page/fully_furnished-a4af1cdc5bbea891f1ffd9b6834b5594.jpg";